// export const getAccessToken = () => localStorage.getItem("token");
// export const getUserType = () => localStorage.getItem("role");
// export const getUserId = () => localStorage.getItem("user_id");
// export const getGroupId = () => localStorage.getItem("group_id");

export const getAccessToken = () => {
  const fromAdmin = sessionStorage.getItem("fromAdmin");

  if (fromAdmin === "1") {
    return sessionStorage.getItem("student_token");
  }

  return localStorage.getItem("token");
};

export const getUserType = () => {
  const fromAdmin = sessionStorage.getItem("fromAdmin");

  if (fromAdmin === "1") {
    return sessionStorage.getItem("student_role");
  }

  return localStorage.getItem("role");
};

export const getUserId = () => {
  const fromAdmin = sessionStorage.getItem("fromAdmin");

  if (fromAdmin === "1") {
    return sessionStorage.getItem("student_user_id");
  }

  return localStorage.getItem("user_id");
};

export const getGroupId = () => {
  const fromAdmin = sessionStorage.getItem("fromAdmin");

  if (fromAdmin === "1") {
    return sessionStorage.getItem("student_group_id");
  }

  return localStorage.getItem("group_id");
};

export const getFromAdminStudent = () => {
  return sessionStorage.getItem("fromAdmin") === "1";
};
